import AjaxService from '../services/ajax-service';
import { handleServerError } from 'shared-services/error-service';
import { convertToFormData } from '../utils/helpers';

export const fetchProjects = ({ archived, limit, offset }) => {
    return AjaxService({
        method: 'get',
        url: `projects`,
        params: {
            archived,
            limit,
            offset
        }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const createProject = ({ name, milestones, task_groups, logo, template_id, subteam, access_type, disabled_modules, default_tasks_view }) => {
    return AjaxService({
        method: 'post',
        url: 'projects',
        data: convertToFormData({
            name,
            milestones,
            task_groups,
            logo,
            template_id,
            subteam_id: subteam,
            access_type,
            disabled: disabled_modules,
            default_tasks_view
        })
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const fetchProject = projectId => {
    return AjaxService({
        method: 'get',
        url: `projects/${projectId}`
    })
        .then(response => response.data)
        .catch(error => {
            handleServerError(error, {
                silent: true
            });
        });
}

export const updateProject = (projectId, { name, logo, archived, subteam, access_type, default_tasks_view }) => {
    return AjaxService({
        method: 'put',
        url: `projects/${projectId}`,
        data: convertToFormData({
            name,
            logo,
            archived,
            subteam_id: subteam,
            access_type,
            default_tasks_view
        })
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const removeProject = projectId => {
    return AjaxService({
        method: 'delete',
        url: `projects/${projectId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const duplicateProject = (projectId, duplicateOptions) => {
    return AjaxService({
        method: 'post',
        url: `projects/${projectId}/clone`,
        data: duplicateOptions
    })
        .then(response => response.data.project)
        .catch(handleServerError);
}

export const inviteProjectUsers = (projectId, invitees) => {
    return AjaxService({
        method: 'post',
        url: `projects/${projectId}/invite`,
        data: {
            invitees: invitees.map(user => ({
                email: user.email,
                role: user.role,
                name: user.name
            }))
        }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const joinProject = projectId => {
    return AjaxService({
        method: 'post',
        url: `projects/${projectId}/join`
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const startProject = projectId => {
    return AjaxService({
        method: 'post',
        url: `projects/${projectId}/start`
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const leaveProject = projectId => {
    return AjaxService({
        method: 'post',
        url: `projects/${projectId}/leave`
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const enableProjectModule = (projectId, module) => {
    return AjaxService({
        method: 'put',
        url: `projects/${projectId}/modules`,
        data: { module }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const disableProjectModule = (projectId, module) => {
    return AjaxService({
        method: 'delete',
        url: `projects/${projectId}/modules`,
        data: { module }
    })
        .then(response => response.data)
        .catch(handleServerError);
}

export const linkProjectRepo = (projectId, fullname) => {
    return AjaxService({
        method: 'post',
        url: `projects/${projectId}/repo`,
        data: { fullname }
    })
        .then(response => response.data)
        .catch(handleServerError);
}
